<h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
<p class="modal-dec">{{message}}</p>
<div class="secondary-button-inner">
  @if(isDeactivateAccount)
  {
    <button (click)="clearToken()" class="btn btn-primary" type="button" data-dismiss="modal">
      <span class="btn-primary-hover"></span>
      <span class="btn-content" >Close</span>
    </button>
  }
  @else if (isAlert) {
    <button class="btn btn-primary" type="button" (click)="activeModal.close();">
      <span class="btn-primary-hover"></span>
      <span class="btn-content">Ok</span>
    </button>
  }
  @else {
  <button class="btn btn-secondary" type="button" (click)="activeModal.close();">
    <span class="btn-secondary-hover"></span>
    <span class="btn-content">Cancel</span>
  </button>
  <button class="btn btn-primary" type="button" data-dismiss="modal" (click)="activeModal.close(true)">
      <span class="btn-primary-hover"></span>
      <span class="btn-content">{{confirmationButtonText}}</span>
    </button>
  }
</div>
